export const locale = {
    lang: 'ds',
    data: {
      'Headers': {
          'ChooseFile': 'Vælg fil',
          'NoFileSelected': 'Ingen fil valgt',
          'BeforeImages': 'Før billeder',
          'AfterImages': 'Efter billeder',
          'AllImages': 'Alle billeder'
      },
      'orderByStatus':{
        'value1':'Dato ↑',
        'value2':'Dato ↓'
      },
      'FILTERS': {
        'SEARCH': 'Search',
        'SORTING_STATUS': 'Black Status',
        'Search_Start_Date': 'Search Start Date',
        'Search_End_Date': 'Search End Date',
        'Folder_Type': "Folder Type"
      }
    }
  };
  